module.exports = __webpack_public_path__ + "static/media/filter.0e1c69bd.svg";